// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (width >= 750px) {
    #groups-page .content {
        padding: 30px;
    }
}
@media (width < 750px) {
    #groups-page .content {
        padding: 10px;
        box-sizing: border-box;
    }
}
`, "",{"version":3,"sources":["webpack://./client/pages/groups/GroupsPage.css"],"names":[],"mappings":";AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;AACJ","sourcesContent":["\n@media (width >= 750px) {\n    #groups-page .content {\n        padding: 30px;\n    }\n}\n@media (width < 750px) {\n    #groups-page .content {\n        padding: 10px;\n        box-sizing: border-box;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
